// extracted by mini-css-extract-plugin
export default {"card":"styles_card__7egtV","header":"styles_header__lQ134","title":"styles_title__URRNt","logo":"styles_logo__RFsbq"};